import { render, staticRenderFns } from "./BaseInputFileLite.vue?vue&type=template&id=204a2e51&scoped=true&"
import script from "./BaseInputFileLite.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileLite.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFileLite.vue?vue&type=style&index=0&id=204a2e51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a2e51",
  null
  
)

export default component.exports